import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { apiCall } from './config';
import Sidebar from './components/Sidebar';

import Login from './components/Login';
import Forecasting from './components/Forecasting';
import OverallSOP from './components/OverallSOP';
import ProductionPlanning from './components/ProductionPlanning';
import ProductionSchedule from './components/ProductionSchedule';
import ComponentPlanning from './components/ComponentPlanning';
import ComponentInventory from './components/ComponentInventory';
import ComponentOrdering from './components/ComponentOrdering';
import BOMComponents from './components/BOMComponents';
import ComponentCosts from './components/ComponentCosts';
import SOPParameters from './components/SOPParameters';
import SKUList from './components/SKUList';
import AuditFGInventory from './components/AuditFGInventory';
import AuditComponentInventory from './components/AuditComponentInventory';
import QBOHistory from './components/QBOHistory';
import ShopifySales from './components/ShopifySales';
import AmazonSales from './components/AmazonSales';
import AmazonSalesData from './components/AmazonSalesData';
import NewAmazonPaymentData from './components/NewAmazonPaymentData';
import PostAmazonPayments from './components/PostAmazonPayments';
import AmazonInventory from './components/AmazonInventory';
import ShopifySalesData from './components/ShopifySalesData';
import ProductProfitAnalysis from './components/ProductProfitAnalysis';
import GlobalForecasting from './components/globalforecasting';
import PLforecast from './components/PLforecast';
import TradeSalesManagement from './components/TradeSalesManagement';
import SundeepInvoiceProcess from './components/SundeepInvoiceProcess';
import SundeepInvoiceMapping from './components/SundeepInvoiceMapping';
import AustinInventory from './components/AustinInventory';
import ShopifySalesReport from './components/ShopifySalesReport';
import MonthlyJournalEntries from './components/MonthlyJournalEntries';
import MonthlyJournalEntriesDepletion from './components/MonthlyJournalEntriesDepletion';
import TestGoogleConnection from './components/TestGoogleConnection';
import ManageAPIConnections from './components/ManageAPIConnections';

function AppContent() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      console.log('=== AUTHENTICATION DEBUG ===');
      console.log('Checking authentication status...');
      console.log('Current URL:', window.location.href);
      console.log('Hostname:', window.location.hostname);
      
      const response = await apiCall('/api/auth/check');
      
      console.log('Auth check response status:', response.status);
      console.log('Auth check response headers:', response.headers);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Auth check response data:', data);
        setIsAuthenticated(data.authenticated);
      } else {
        console.log('Auth check failed with status:', response.status);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      await apiCall('/api/auth/logout', { method: 'POST' });
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setIsAuthenticated(false);
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <Sidebar />
      <div className="main-content">
        <Routes>
          <Route path="/" element={
            <div className="landing-page" style={{
              position: 'relative',
              width: '100%',
              height: '100vh',
              margin: 0,
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              maxWidth: 'none',
              borderRadius: '0',
              boxShadow: 'none',
              border: 'none',
              background: 'transparent'
            }}>
              {/* Background image */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: 'url(/DSC00167-removebg-preview_1.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              }}></div>
              
              {/* Dark overlay */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
              }}></div>
              
              {/* Content */}
              <div style={{
                position: 'relative',
                zIndex: 2,
                textAlign: 'center',
                color: 'white',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}>
                <h1 style={{
                  fontSize: '3rem',
                  fontWeight: 'bold',
                  margin: 0,
                  padding: 0
                }}>Ingreendients Planning Application</h1>
              </div>
            </div>
          } />
          <Route path="/overall-sop" element={<OverallSOP />} />
          <Route path="/forecasting" element={<Forecasting />} />
          <Route path="/global-forecasting" element={<GlobalForecasting />} />
          <Route path="/cash-forecasting" element={<PLforecast />} />
          <Route path="/production-planning" element={<ProductionPlanning />} />
          <Route path="/component-inventory" element={<ComponentInventory />} />
          <Route path="/production-schedule" element={<ProductionSchedule />} />
          <Route path="/component-planning" element={<ComponentPlanning />} />
          <Route path="/component-ordering" element={<ComponentOrdering />} />
          <Route path="/bom-components" element={<BOMComponents />} />
          <Route path="/component-costs" element={<ComponentCosts />} />
          <Route path="/sop-parameters" element={<SOPParameters />} />
          <Route path="/sku-list" element={<SKUList />} />
          <Route path="/sundeep-invoice-mapping" element={<SundeepInvoiceMapping />} />
          <Route path="/audit-fg-inventory" element={<AuditFGInventory />} />
          <Route path="/audit-component-inventory" element={<AuditComponentInventory />} />
          <Route path="/qbo-history" element={<QBOHistory />} />
          <Route path="/shopify-sales" element={<ShopifySales />} />
          <Route path="/amazon-sales" element={<AmazonSales />} />
          <Route path="/amazon-sales-data" element={<AmazonSalesData />} />
                  <Route path="/new-amazon-payment-data" element={<NewAmazonPaymentData />} />
        <Route path="/post-amazon-payments" element={<PostAmazonPayments />} />
          <Route path="/amazon-inventory-data" element={<AmazonInventory />} />
          <Route path="/shopify-sales-data" element={<ShopifySalesData />} />
          <Route path="/trade-sales-management" element={<TradeSalesManagement />} />
          <Route path="/profit-analysis" element={<ProductProfitAnalysis />} />
          <Route path="/invoice-processing" element={<SundeepInvoiceProcess />} />
          <Route path="/journal-entries" element={<MonthlyJournalEntries />} />
          <Route path="/journal-entries-depletion" element={<MonthlyJournalEntriesDepletion />} />
          <Route path="/austin-inventory" element={<AustinInventory />} />
          <Route path="/shopify-sales-report" element={<ShopifySalesReport />} />
          <Route path="/test-google-connection" element={<TestGoogleConnection />} />
        <Route path="/manage-api-connections" element={<ManageAPIConnections />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
